/* N0Dir8kti0n – Produktgalerie: immer nur ein Bild, weiter per Pfeil, Punkt, Wischen,
   Trackpad oder Maus-Ziehen. Baut sich neu auf, wenn sich die Bilder (Farbwechsel) ändern. */
(function () {
  if (window.N0Gallery) return;

  class N0Gallery {
    constructor(root) {
      this.root = root;
      this.list = root.querySelector('.product__media-list');
      this.nav = root.querySelector('.n0-gallery__nav');
      this.prev = root.querySelector('.n0-gallery__arrow--prev');
      this.next = root.querySelector('.n0-gallery__arrow--next');
      this.dotsWrap = root.querySelector('.n0-gallery__dots');
      if (!this.list || !this.nav) return;

      this.index = 0;
      this.ticking = false;

      this.prev.addEventListener('click', () => this.go(this.index - 1));
      this.next.addEventListener('click', () => this.go(this.index + 1));
      this.list.addEventListener('scroll', () => this.onScroll(), { passive: true });
      this.list.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1); }
      });
      window.addEventListener('resize', () => this.go(this.index, false));

      this.initDrag();

      // Farbwechsel: Dawn tauscht die <li> im Slider aus -> neu aufbauen, zurück zu Bild 1
      this.observer = new MutationObserver(() => {
        window.clearTimeout(this.rebuildTimer);
        this.rebuildTimer = window.setTimeout(() => this.build(true), 30);
      });
      this.observer.observe(this.list, { childList: true });

      this.build(false);
    }

    slides() {
      return Array.from(this.list.children).filter(
        (el) => el.matches('.product__media-item') && el.getClientRects().length > 0
      );
    }

    build(reset) {
      const slides = this.slides();
      const count = slides.length;
      this.nav.hidden = count < 2;
      this.root.classList.toggle('n0-gallery--single', count < 2);
      this.dotsWrap.innerHTML = '';
      this.dots = slides.map((slide, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'n0-gallery__dot';
        dot.setAttribute('aria-label', `Bild ${i + 1} von ${count}`);
        dot.addEventListener('click', () => this.go(i));
        this.dotsWrap.appendChild(dot);
        return dot;
      });
      if (reset) {
        this.list.scrollTo({ left: 0, behavior: 'auto' });
        this.index = 0;
      }
      this.sync();
    }

    currentIndex() {
      const slides = this.slides();
      if (!slides.length) return 0;
      const x = this.list.scrollLeft;
      let best = 0;
      let bestDist = Infinity;
      slides.forEach((s, i) => {
        const d = Math.abs(s.offsetLeft - slides[0].offsetLeft - x);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    }

    go(i, smooth = true) {
      const slides = this.slides();
      if (!slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      this.index = i;
      this.list.scrollTo({
        left: slides[i].offsetLeft - slides[0].offsetLeft,
        behavior: smooth ? 'smooth' : 'auto',
      });
      this.sync(i);
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.ticking = false;
        if (!this.dragging) this.sync();
      });
    }

    sync(forced) {
      const slides = this.slides();
      const i = typeof forced === 'number' ? forced : this.currentIndex();
      this.index = i;
      (this.dots || []).forEach((d, n) => {
        d.classList.toggle('is-active', n === i);
        if (n === i) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
      this.prev.disabled = i <= 0;
      this.next.disabled = i >= slides.length - 1;
      slides.forEach((s, n) => s.classList.toggle('is-active', n === i));
    }

    // Maus-Ziehen am Desktop (Touch nutzt natives Wischen)
    initDrag() {
      const list = this.list;
      let startX = 0;
      let startScroll = 0;
      let moved = false;
      let down = false;

      list.addEventListener('dragstart', (e) => e.preventDefault());

      list.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse' || e.button !== 0 || this.slides().length < 2) return;
        down = true;
        moved = false;
        startX = e.clientX;
        startScroll = list.scrollLeft;
        this.startIndex = this.currentIndex();
      });

      window.addEventListener('pointermove', (e) => {
        if (!down) return;
        const dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 6) {
          moved = true;
          this.dragging = true;
          list.classList.add('is-dragging');
        }
        if (moved) list.scrollLeft = startScroll - dx;
      });

      const end = (e) => {
        if (!down) return;
        down = false;
        if (!moved) return;
        const dx = e.clientX - startX;
        list.classList.remove('is-dragging');
        this.dragging = false;
        let target = this.startIndex;
        if (dx < -50) target += 1;
        else if (dx > 50) target -= 1;
        this.go(target);
        // Klick nach dem Ziehen nicht als "Bild vergrößern" werten
        const block = (ev) => { ev.preventDefault(); ev.stopPropagation(); };
        list.addEventListener('click', block, { capture: true, once: true });
        window.setTimeout(() => list.removeEventListener('click', block, { capture: true }), 50);
      };
      window.addEventListener('pointerup', end);
      window.addEventListener('pointercancel', end);
    }
  }

  window.N0Gallery = N0Gallery;

  const initAll = (scope = document) => {
    scope.querySelectorAll('media-gallery.n0-gallery').forEach((el) => {
      if (el.n0Gallery) return;
      el.n0Gallery = new N0Gallery(el);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
